
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`La petite histoire`}</em></p>
    <p>{`Dans cette course au vaccin, les candidats venus de Chine sont les plus
nombreux. Pour l’anecdote, ils ont rencontré une difficulté: comme les cas de
coronavirus étaient devenus rares dans l’Empire du milieu, des tests cliniques
ont dû être menés dans d’autres pays, là où la circulation du virus est encore
importante.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;